import styled from 'styled-components';

import Image from '@shared/Image';
import Button from '@components/Button';

export const Preview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 960px;
  width: 100%;
`;

export const CarCardWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  max-width: calc(100% - 32px);
  width: 100%;
  margin: 0px auto;
  overflow: hidden;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.white};

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    flex-direction: row;
    max-width: 960px;
  }

  .carCard__flipContainer {
    width: 100%;
  }
`;

export const CardFrontWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    flex-direction: row;
  }
`;

export const CardColStyled = styled.div<{
  flex?: number;
  hasBorderLeft?: boolean;
}>`
  padding: 17px 30px 17px 20px;
  flex: ${(props) => props.flex};
  border-left: none;
  border-top: ${(props) =>
    props.hasBorderLeft ? `solid 1px ${props.theme.palette.gray87}` : 'none'};

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    border-left: ${(props) =>
      props.hasBorderLeft ? `solid 1px ${props.theme.palette.gray87}` : 'none'};
    border-top: none;
  }
`;

export const CarModel = styled.h1`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 0px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    font-size: 18px;
  }
`;

export const CarAlernativeModelText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.primaryBrand};
  margin-bottom: 0px;
  height: 50px;
`;

export const LeftColWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    flex-direction: row;
  }
`;

export const InfoListStyled = styled.ul`
  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    margin-left: auto;
  }
`;

export const InfoListItemStyled = styled.li`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 5px;

  &.infoListItem__providerImage {
    margin-top: 0.75rem;
  }
`;

export const InfoListTitle = styled.h1`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const RightColWrapperStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    flex-direction: column;
    justify-content: center;
  }

  .carRentalCard__payButton {
    margin-top: 0px;

    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      margin-top: 1rem;
    }
  }
`;

export const PriceInfoStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.25rem;
`;

export const DailyAndTotalPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const DailyPriceTitleStyled = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primaryBrand};
`;

export const PriceTitleStyled = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primaryBrand};
`;

export const CarType = styled.h3`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primaryBrand};
  margin-bottom: 0px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    font-size: 15px;
  }
`;

export const FlipButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  border: 0;
  margin-left: auto;
  font-size: 8px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primaryBrand};
  background-color: transparent;
  gap: 3px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    font-size: 11px;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const InfoDetailWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  flex-basis: 50%;
  max-width: 50%;
  margin-bottom: 1rem;
`;

export const CardFrontHeaderWrapper = styled.div<{
  hasBorderBottom?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: ${(props) =>
    props.hasBorderBottom ? `1px solid ${props.theme.palette.gray87}` : 'none'};
  margin-bottom: ${(props) => (props.hasBorderBottom ? '1rem' : '0px')};
`;

export const CardFrontBodyWrapper = styled.div`
  display: flex;
`;

export const VehicleSpecificationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 50%;
  max-width: 50%;
  padding: 0 24px;

  &:first-child {
    border-right: 1px solid ${({ theme }) => theme.palette.gray87};
    padding-left: 0px;
  }

  h6 {
    font-size: 10px;
    font-weight: 700;
    margin-bottom: 16px;

    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      font-size: 14px;
    }
  }

  ul {
    li {
      display: flex;
      gap: 4px;
      font-size: 12px;

      ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
        font-size: 14px;
      }

      & + li {
        margin-top: 8px;
      }
    }
  }
`;

export const CarCarouselWrapper = styled.div`
  max-width: 450px;
  width: 100%;
`;

export const CarCarouselDotsWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 1rem;
`;

export const CarCarouselItem = styled.div`
  max-width: 100%;

  img {
    max-width: 100%;
    object-fit: contain;
  }
`;

export const ProviderImage = styled(Image)`
  object-fit: contain;
`;

export const CircleButton = styled(Button).attrs({
  variant: 'link',
})`
  min-width: 32px;
  width: 32px;
  height: 32px;
  padding-inline-start: 0;
  padding-inline-end: 0;
  border-radius: 50%;
  border: 1px solid #d9d9d9;
  background: ${({ theme }) => theme.palette.white};
  color: rgba(0, 0, 0, 0.88);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);

  &:disabled {
    cursor: not-allowed;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
    background: rgba(0, 0, 0, 0.04);
    box-shadow: none;

    &:hover {
      cursor: not-allowed;
      border-color: #d9d9d9;
      color: rgba(0, 0, 0, 0.25);
      background: rgba(0, 0, 0, 0.04);
      box-shadow: none;
    }
  }

  &:hover {
    color: ${({ theme }) => theme.palette.primaryBrand};
    border: 1px solid ${({ theme }) => theme.palette.primaryBrand};
    background: ${({ theme }) => theme.palette.white};
  }
`;
